import { useTranslate } from "@tolgee/react";
import { RotateCw } from "lucide-react";
import { Button } from "#/components/ui/button";
import { useRefreshAssets } from "#/hooks/use-refresh-assets";
import { useWallet } from "#/hooks/use-wallet";
import { cn } from "#/lib/utils";

/**
 * Icon button that manually refetches account + balances via `useRefreshAssets`.
 * Spins while in flight and disables itself during the anti-spam cooldown.
 * Used in the portfolio wallet card header and the header account menu.
 * Renders nothing when disconnected.
 */
export function RefreshAssetsButton({ className }: { className?: string }) {
	const { t } = useTranslate();
	const { isConnected } = useWallet();
	const { refresh, isRefreshing, disabled } = useRefreshAssets();

	if (!isConnected) return null;

	return (
		<Button
			variant="ghost"
			size="icon-xs"
			onClick={refresh}
			disabled={disabled}
			aria-busy={isRefreshing}
			aria-label={t("actions.refresh")}
			title={t("actions.refresh")}
			className={cn("text-muted-foreground", className)}
		>
			<RotateCw className={cn("h-3.5 w-3.5", isRefreshing && "animate-spin")} />
		</Button>
	);
}
